import { SET_CANCEL, RESET_CANCEL } from 'actionTypes';

const initialState = {
  matches: null,
  inbox: null,
  contactSummary: null,
  dailyRecommendations: null,
};
export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CANCEL: {
      return { ...state, [action.payload.source]: action.payload.cancelFn };
    }

    case RESET_CANCEL: {
      const newState = { ...state };
      action.payload.source.forEach(source => {
        newState[source] = null;
      });

      return newState;
    }
    default: {
      return state;
    }
  }
}
